type FbqFn = (...args: unknown[]) => void

declare global {
  interface Window {
    fbq?: FbqFn
  }
}

const trackMetaPixelEvent = (name: string, params?: Record<string, unknown>) => {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return
  window.fbq('track', name, params)
}

// Fires when a user views the prize draw listing page or an individual draw's detail page.
export const trackPrizeDrawView = (params: {
  contentIds?: (string | number)[]
  contentName?: string
}) =>
  trackMetaPixelEvent('ViewContent', {
    content_type: 'prize_draw',
    content_ids: params.contentIds?.map(String),
    content_name: params.contentName,
  })

// Fires once a wallet deposit (top-up) actually completes.
export const trackDeposit = (params: { value: number; currency?: string }) =>
  trackMetaPixelEvent('Purchase', { value: params.value, currency: params.currency ?? 'GBP' })
